module.exports = __webpack_public_path__ + "img/white-circle-plus.3410a306.svg";